import getUseWatch from '../../../../helpers/forms/get-use-watch'
import FormValues, { FormInstance } from '../types/form-values'

const useWatch = getUseWatch<FormValues, FormInstance>()

export default useWatch
